import {createElement, Component, PropTypes} from 'rlink-react';

import themeable from 'rlink-theme/themeable';


export default function Tab ({theme, children}) {
  return (<div className={`${theme.TabContent}`}>
    {children}
  </div>);
}

/* eslint-disable */
Tab.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.node,
  onTabClick: PropTypes.func,
};
/* eslint-enable */

Tab.defaultProps = {
  name: '',
  active: false,
};

themeable(Tab, {
  classes: ['TabContent'],
});



// WEBPACK FOOTER //
// ./lib/rlink-tabs/components/Tab.jsx